import styled, { keyframes } from 'styled-components';

const animatePath = keyframes`
    from {
        stroke-dashoffset: ${props => props.pathLength};
    }

    to {
        stroke-dashoffset: 0;
    }
`;

const SVGLoadingPath = styled.svg`
    animation: ${animatePath} ${props => props.theme.loading.duration} linear infinite;
    fill: none;
    height: ${props => props.theme.loading.height};
    left: 50%;
    opacity: ${props => props.loading ? '1' : '0'};
    overflow: visible;
    position: fixed;
    stroke-dasharray: ${props => props.pathLength}, ${props => props.pathLength / 2}, ${props => props.pathLength};
    stroke-dashoffset: ${props => props.pathLength + props.pathLength / 2};
    stroke-linecap: ${props => props.theme.loading.strokeLinecap};
    stroke-miterlimit: 10;
    stroke-width: ${props => props.theme.loading.strokeWidth};
    stroke: ${props => props.theme.loading.stroke};
    top: 50%;
    transform: ${props => props.loading ? 'translate(-50%, -50%)' : 'translate(-50%, 50%)'};
    transition: opacity ${props => props.theme.transition.duration} ${props => props.theme.transition.easeOut}, transform ${props => props.theme.transition.duration} ${props => props.theme.transition.easeOut};
    width: ${props => props.theme.loading.width};
    z-index: ${props => props.loading ? '1' : '-1'};
`;

export default SVGLoadingPath;


// WEBPACK FOOTER //
// ./src/components/atoms/Loading/Loading.styled.js